import React from 'react';
import styles from './TeamLogo.module.css';
import { getStoredTheme } from '../utils/theme';

interface TeamLogoProps {
  teamKey: string;
  logoSize?: number;
  marginSize?: number;
}

// Teams that need their logos inverted in dark mode
const TEAMS_TO_INVERT = [
  'asterisk-women',
  'fut-esports',
  'paper-rex',
  'team-vitality',
  'karmine-corp',
  'tsm',
  'fearx',
  'majestic',
  'ulf-esports',
  'mibr',
  'kcorp-blue-stars',
  'voidwalkers',
  'catnappers',
  'orgless-2-0',
  'aka-hero',
  'aim-ph',
  'ambitious-legend-gaming-gc',
  'apeks',
  'ascend',
  'asterisk',
  'aura',
  'bitfix-gaming',
  'bonk',
  'cgn-esports',
  'chaos-alliance',
  'cicadas-gaming',
  'cloud9-x-shopify-rebellion',
  'disguised',
  'dnsty',
  'dplus-esports',
  'echo-aura',
  'evil-geniuses',
  'envy',
  'fav-gaming',
  'fennel',
  'fennel-gc',
  'five-media-clan',
  'formulation-gaming',
  'furious-gaming',
  'fuzos',
  'gamax-esports',
  'gentle-mates',
  'ghost-gaming',
  'giantx',
  'giantx-gc',
  'gmblers-esports',
  'himothys',
  'igzist',
  'imperium-gaming',
  'impulse-gw',
  'joblife',
  'karmine-corp-gc',
  'kadiliman',
  'level-5',
  'loneteam',
  'looking-for-money-la-familia',
  'los-grandes',
  'mad-army',
  'melilla-titans',
  'mibr-academy',
  'mibr-gc',
  'mir',
  'nightblood-gaming',
  'nom-esports',
  'northeption-youth',
  'nxt',
  'onyx-ravens',
  'oomfies',
  'otakar-esports',
  'papara-supermassive',
  'paper-rex-x-spotlight-series',
  'permitta-unicorns',
  'polar-squad-esports-gc',
  'prasso-clan',
  'prosperity-esports',
  'questionmarks',
  'rafha-esports',
  'reject',
  'revenant-xspark',
  'rival-esports',
  'rvn',
  'sagaz',
  'sasanqua',
  'shopify-rebellion',
  'six-karma',
  'sk-nebula',
  'striderz',
  'team-secret',
  'team-secret-academy',
  'team-seibi',
  'the-7',
  'todak',
  'true-rippers',
  'urachacha',
  'vit-revolution',
  'xperion-nxt',
  'zeta-division',
  'zeta-division-academy',
  'zeta-division-gc',
  'zeta-gaming',
  'zol-esports',
  '3',
];

const TeamLogo: React.FC<TeamLogoProps> = ({ teamKey, logoSize = 16, marginSize = 12 }) => {
  const logoUrl = `https://valolens-team-logos-891612567998.s3.amazonaws.com/${teamKey}.png`;
  const currentTheme = getStoredTheme();
  const shouldInvert = currentTheme === 'dark' && TEAMS_TO_INVERT.includes(teamKey.toLowerCase());

  return (
    <div className="d-inline-block">
      <img
        src={logoUrl}
        alt={`${teamKey} logo`}
        className={`img-fluid ${styles.logo}`}
        style={{ 
          height: `${logoSize}px`, 
          width: `${logoSize}px`, 
          marginRight: `${marginSize}px`,
          filter: shouldInvert ? 'invert(0.8)' : 'none'
        }}
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.onerror = null;
          target.src = '/question-mark.png';
        }}
      />
    </div>
  );
};

export default TeamLogo;
